import React from 'react'
import { getValueElement, printKey } from '../TableCompare/utils'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import Typography from '@mui/material/Typography'
import isEmpty from 'lodash/isEmpty'

const TableCompareRow = ({ field, oldValues, newValues }) => {
  const idsOld = oldValues[field]?.map(license => license._id)
  const idsNew = newValues[field]?.map(license => license._id)
  const ids = [...idsOld, ...idsNew]
  const uniqueIds = [...new Set(ids)]
  return uniqueIds.map((id, index) => {
    let action = 'updated'
    const fields = [];
    const oldItem = oldValues[field]?.find(license => license._id === id) || {}
    const newItem = newValues[field]?.find(license => license._id === id) || {}
    if (isEmpty(oldItem)) {
      action = 'created'
    }
    if (isEmpty(newItem)) {
      action = 'deleted'
    }

    Object.keys(oldItem)?.forEach(key => {
      if (oldItem[key] !== null && !fields.includes(key)) {
        fields.push(key)
      }
    })

    Object.keys(newItem)?.forEach(key => {
      if (newItem[key] !== null && !fields.includes(key)) {
        fields.push(key)
      }
    })

    return (
      <>
      <TableRow key={`table-columd-body-${field}-${index}`}>
        <TableCell width={100} className='overflow-hidden' rowSpan={fields.length + 1}>
          <Typography variant='inherit' className=''>
            {newItem?.name || oldItem?.name}
          </Typography>
          <Typography component={'p'} variant='inherit' className='font-bold text-2xs uppercase' color='primary'>
            {action}  
          </Typography>
        </TableCell>
       
      </TableRow>
       {fields.map((fieldKey, index) => (
        <TableRow key={`fieldKey-${fieldKey}-${index}`}>
          <TableCell className='overflow-hidden max-w-200px'>
            <Typography variant='inherit' className='font-bold text-sm' color='primary'>
              {printKey(fieldKey)}
            </Typography>
          </TableCell>
          <TableCell className='overflow-hidden max-w-200px'>
            <Typography variant='inherit' className='font-bold text-sm' color='primary'>
              {getValueElement(oldItem[fieldKey], fieldKey)}
            </Typography>
          </TableCell>
          <TableCell className='overflow-hidden max-w-200px'>
            <Typography variant='inherit' className='font-bold text-sm' color='primary'>
              {getValueElement(newItem[fieldKey], fieldKey)}
            </Typography>
          </TableCell>
        </TableRow>
      ))}
      </>
    )
  })
}
export default TableCompareRow